import { isMobile } from 'react-device-detect';

export const isDeviceMobile = isMobile;
export const isDeviceDesktop = !isMobile;
